export enum TopicType {
  OTHER = '1',
  STYLE = '2',
  LINE_ITEM = '3',
}
